import { Dispatch } from "@reduxjs/toolkit";

import {
  SET_IS_LOADING_FILE,
  SET_IS_PRINT_SERVICE_UNAVAILABLE,
} from "../redux/slices/appSlice";
import fetchFile from "../hooks/fetchFile";

export const handlePrintExportFile = async (
  dispatch: Dispatch,
  url: string,
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  dispatch(SET_IS_LOADING_FILE(true));

  const res = await fetchFile(url, isToUseAuthZero, accessToken);

  dispatch(SET_IS_LOADING_FILE(false));
  dispatch(SET_IS_PRINT_SERVICE_UNAVAILABLE(!res.ok));
};
